export const normalizePaddedNumbersRange = (rangeStart: number, rangeEnd: number) => {
    const rule = rangeStart < 0 ? /^-?(?:\d+|\d*)$/ : /^[0]?[0-9]+$/;
    return (value: string, previousValue: string) => {
        if (!value) return '';
        if (!rule.test(value)) return previousValue;
        const valueInt = parseInt(value);
        if (isNaN(valueInt)) return value;
        if (valueInt < rangeStart || valueInt > rangeEnd) return previousValue;
        return value;
    };
};

export const roundToDecimal = (num: number, decimalPlaces: number) => {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

export const truncateToSigFig = (num: number, sigFig: number) => {
    if (num === 0) return 0;
    const decimalPlaces = sigFig - (1 + Math.floor(Math.log10(Math.abs(num))));
    const factor = Math.pow(10, decimalPlaces);
    return Math.floor(num * factor) / factor;
};
